export default __webpack_public_path__ + "static/media/docIcon.a6ccba87.svg";